import * as Model from "../../model"

export function isLocalAuthority(model: any): model is Model.LocalAuthority {
	const localAuthority = model as Model.LocalAuthority
	return undefined !== localAuthority.code
	&& undefined !== localAuthority.id
	&& undefined !== localAuthority.name
}



// WEBPACK FOOTER //
// ./src/domain/sfp/model-domain.ts